import _sortBy from 'lodash/sortBy'

const sortUtterances = (utterances) => {
  return _sortBy(utterances, ['createdAt'])
}

export default {
  namespaced: true,
  state: {
    activeCandidates: [],
    inactiveCandidates: [],
    jobs: [],
    candidate: {},
    utterances: [],
    job: {},
    templates: [],
    scoutTemplates: []
  },
  getters: {
    activeCandidates(state) {
      return state.activeCandidates
    },
    inactiveCandidates(state) {
      return state.inactiveCandidates
    },
    activeJobs(state) {
      return state.jobs.filter(job => job.status === 1)
    },
    inactiveJobs(state) {
      return state.jobs.filter(job => job.status === 2)
    },
    candidate(state) {
      return state.candidate;
    },
    utterances(state) {
      return state.utterances
    },
    candidateUnreadCountTotal(state) {
      let count = 0;
      for (let job of state.jobs) {
        count += job.unreadCount;
      }
      return count;
    },
    allNewCount(state) {
      let count = 0;
      for (let candidates of state.activeCandidates) {
        count += candidates.unreadCount;
      }
      for (let candidates of state.inactiveCandidates) {
        count += candidates.unreadCount;
      }
      return count;
    },
    templates(state) {
      return state.templates
    },
    scoutTemplates(state) {
      return state.scoutTemplates
    }
  },
  mutations: {
    setUserMessages(state, payload) {
      state.jobs = payload.messages;
    },
    setClientMessages(state, payload) {
      state.activeCandidates = payload.actives
      state.inactiveCandidates = payload.inactives
    },
    setStatus(state, payload) {
      state.jobs = state.jobs.map(job => {
        if (job.id === payload.id) {
          return {
            ...job,
            status: payload.status
          }
        }
        return job
      })
    },
    setUtterances(state, payload) {
      state.utterances = sortUtterances(payload.utterances)
    },
    addUtteranceToMessage(state, payload) {
      state.utterances = sortUtterances(state.utterances.concat(payload.utterance))
    },
    setUtteranceIsRead(state, payload) {
      state.utterances = state.utterances.map(utterance => {
        if (utterance.id === payload.utteranceId) {
          return {
            ...utterance,
            isRead: payload.isRead
          }
        }
        return utterance
      })
      state.activeCandidates = state.activeCandidates.map(candidate => {
        if (candidate.id === payload.id) {
          return {
            ...candidate,
            unreadCount: 0
          }
        }
        return candidate
      })
      state.inactiveCandidates = state.inactiveCandidates.map(candidate => {
        if (candidate.id === payload.id) {
          return {
            ...candidate,
            unreadCount: 0
          }
        }
        return candidate
      })
      state.jobs = state.jobs.map(job => {
        if (job.id === payload.id) {
          return {
            ...job,
            unreadCount: 0
          }
        }
        return job
      })
    },
    pushTemplate(state, {template}) {
      state.templates.unshift(template)
    },
    pushScoutTemplate(state, {template}) {
      state.scoutTemplates.unshift(template)
    },
    setTemplates(state, {templates}) {
      state.templates = templates
    },
    setScoutTemplates(state, {templates}) {
      state.scoutTemplates = templates
    },
    setTemplate(state, {template}) {
      state.templates = state.templates.map(item => {
        if (item.id === template.id) {
          return template
        }
        return item
      })
    },
    setScoutTemplate(state, {template}) {
      state.scoutTemplates = state.scoutTemplates.map(item => {
        if (item.id === template.id) {
          return template
        }
        return item
      })
    },
    deleteTemplate(state, {templateId}) {
      state.templates = state.templates.filter(template => template.id !== templateId)
    },
    deleteScoutTemplate(state, {templateId}) {
      state.scoutTemplates = state.scoutTemplates.filter(template => template.id !== templateId)
    }
  },
  actions: {
    fetchUserMessages({commit}, {messages, unreadTotal}) {
      commit("setUserMessages", {
        messages: messages,
        unreadTotal: unreadTotal
      })
    },
    fetchCompanyMessages({commit}, {actives, inactives}) {
      commit("setClientMessages", {
        actives: actives,
        inactives: inactives
      })
    },
    updateStatus({commit}, {id, status}) {
      commit("setStatus", {
        id: id,
        status: status
      })
    },
    fetchUtterances({commit}, {utterances}) {
      commit("setUtterances", {
        utterances: utterances
      })
    },
    clearUtterances({commit}) {
      commit("setUtterances", {
        utterances: []
      })
    },
    addUtterance({commit}, {utterance}) {
      commit("addUtteranceToMessage", {
        utterance: utterance
      })
    },
    updateIsRead({commit}, {id, utteranceId, isRead}) {
      commit("setUtteranceIsRead", {
        id: id,
        utteranceId: utteranceId,
        isRead: isRead
      })
    },
    addTemplate({commit}, {template}) {
      commit("pushTemplate", {template})
    },
    addScoutTemplate({commit}, {template}) {
      commit("pushScoutTemplate", {template})
    },
    updateTemplates({commit}, {templates}) {
      commit("setTemplates", {templates})
    },
    updateScoutTemplates({commit}, {templates}) {
      commit("setScoutTemplates", {templates})
    },
    updateTemplate({commit}, {template}) {
      commit("setTemplate", {template})
    },
    updateScoutTemplate({commit}, {template}) {
      commit("setScoutTemplate", {template})
    },
    removeTemplate({commit}, {templateId}) {
      commit("deleteTemplate", {templateId})
    },
    removeScoutTemplate({commit}, {templateId}) {
      commit("deleteScoutTemplate", {templateId})
    }
  }
}